import * as api from 'services/ErplyAPI/productUnits';
import * as c from 'constants/productUnitsDB';
import { PRODUCT_UNITS } from 'containers/EssentialDataLoader/constants';
import { createAsyncThunkWithIndexedDbPersister } from 'containers/EssentialDataLoader/utils';

export const fetchProductUnits = createAsyncThunkWithIndexedDbPersister(
  PRODUCT_UNITS,
  c.FETCH_PRODUCT_UNITS,
  async () => api.getProductUnits(),
);
